export default __webpack_public_path__ + "static/media/conectivity.fe8f1a78.svg";